export default __webpack_public_path__ + "static/picto-trucs-black-203b621c08cd2bb928d57b423d70dd39.png";